<form class="full-size-block" #form [formGroup]="form_group" (focusin)="showList(); text.select()"
    (keyup)="downArrow($event)" (focusout)="hideList($event,1)">
    <!-- (focusout)="hideList($event , 1)" -->

    <!-- {{ label }} -->
    <div class="input-group" style="width:100%">
        <input class="input-search pr-1" [ngStyle]="style" [ngClass]="{'input-search-placeholder': inp_search =='1'}"
            style="border: none;height: 20px !important;font-size: 13px; padding-bottom: .1rem !important;" type="text"
            autocomplete="off" [placeholder]="placeholder" [formControl]="qwe" #text (keydown)="filter($event)"
            (keyup)="filter($event)" [required]="mandatory" [name]="random_id">
        <div class="input-group-append p-0 pointer" style="width:13px;margin-top: 5px !important;"
            (click)="onSelectNone($event)">
            <i *ngIf="this.qwe&&this.qwe.value&&enable_close&&this.qwe.value!='Any'" class="fa fa-times" matSuffix></i>
        </div>
        <div class="input-group-append p-0 pointer" (click)="showList();"
            style="width:13px;justify-content: center;margin-top: 5px !important;">
            <i class="fa fa-angle-down" matSuffix></i>
        </div>
    </div>
    <!--[ngClass]="form_group.get(this.form_control).touched? 'touched':'untouched'"-->

    <cdk-virtual-scroll-viewport #view id="view" class="cdk"
        style="opacity: 1; pointer-events: auto;z-index: 1001;overflow: auto;font-size: 13px;" *ngIf="search_valid"
        itemSize="20" class="viewport select-menu" [style.width]=" dimension_width +'px'"
        [style.position]="!display_overlay ? 'fixed' : 'absolute'" [style.top.px]="top" [style.left.px]="left">
        <!-- <li class="select-options" (click)="onSelectNone($event)" value="null" *ngIf="!mandatory &&
      (filtered_input !=null || filtered_input != undefined) && filtered_input.length > 0">
            {{ 'none' }}
        </li> -->
        <ng-container *cdkVirtualFor="let input of (filtered_input); let i = index">
            <li *ngIf="input && !input.hidden" class="select-options options p-0" [class.active]="i == arrow_key_location"
                [value]="input[id_property]">
                <div class="row m-0 ">
                    <div [class]="edit_option==true?'col-md-10':'col-md-12' " (click)="onSelect($event, input)"
                        id="active" class="p-0 active-div" style="padding: 5px !important;">
                        <span class="option-active" style="width:80%">{{ input[title_property] }}</span>
                    </div>
                    <div class="col-xs-2 col-md-2 p-0 option-active" (click)="onEdit($event, input)"
                        style="padding:5px !important;" *ngIf="edit_option">
                        <span style="width:20%" style="float: right;"><i class="fa fa-pencil"></i></span>
                    </div>
                </div>
            </li>
        </ng-container>
        <li *ngIf="filtered_input ==null || filtered_input == undefined || filtered_input.length == 0 "
            class="select-options"> No data found!</li>
    </cdk-virtual-scroll-viewport>

    <div id="overlay_mat_select_search" *ngIf="display_overlay"
        style="position: fixed;width: 100%;height: 100%;z-index: 1000;left: 0;top: 0;">
    </div>
</form>